module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC6SURBVHgB5ZMxDsIwDEU/EgusZYS1rGVlZSXn4AAcpndg5gwwAiPMXVlZwZZsybICiunYJz1VTqRfu0mBwTHKrC3ICeI8WR9Yk3v8x5Vsx182d4ixlWaggRuyIadSR7psbaGBjTwvYimJnOcCmTt5RIzkF2zgipyhJ/5Q3uiJDeRvFx15/Stw6fb4op5RFlpBprOBvFibuisM5FN+kTcfeEJ8ZOZAPrTQQH5DQuYaRNF/uRKjcCMdhs0HHRgbHsOyGYkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/cardimg.png
// module id = x9ax
// module chunks = 4